import { useEffect, useRef } from 'react'

import {
  buildPaywallViewedProperties,
  MixpanelEvents,
  trackEvent,
} from '../../../services/analytics'

interface UseTrackPaywallViewedParams {
  hasResolvedOptions: boolean
  isVisible: boolean
  packageCount: number
  selectedPackageIdentifier: string | null
}

export function useTrackPaywallViewed({
  hasResolvedOptions,
  isVisible,
  packageCount,
  selectedPackageIdentifier,
}: UseTrackPaywallViewedParams) {
  const paywallViewedRef = useRef(false)
  const paywallOpenTimeRef = useRef<number | null>(null)
  const hasResolvedInitialSelection =
    selectedPackageIdentifier != null || packageCount === 0

  useEffect(() => {
    if (
      !isVisible ||
      !hasResolvedOptions ||
      !hasResolvedInitialSelection ||
      paywallViewedRef.current
    ) {
      return
    }

    paywallViewedRef.current = true
    paywallOpenTimeRef.current = Date.now()
    trackEvent(
      MixpanelEvents.PaywallViewed,
      buildPaywallViewedProperties({
        trigger: 'signup_flow',
        planShown: selectedPackageIdentifier ?? undefined,
      }),
    )
  }, [
    hasResolvedInitialSelection,
    hasResolvedOptions,
    isVisible,
    selectedPackageIdentifier,
  ])

  return { paywallOpenTimeRef }
}
